import _ from "lodash";

export default {
    methods: {
        async getRole(){
            await this.getToController(
                'get_current_role',
                'Ошибка',
                (response)=>{
                    this.check_umu_role = _.filter(response.data, (i)=>{return i.name === "umu"});
                    this.checkAdminRole = _.filter(response.data, (i)=>{return i.name === "admin"})
                }
            );
        },
    }

}